import homepage from './pages/home/fullpage';

$(window).resize(function() {
  homepage();
});